"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FileSaver = require("file-saver");
var React = require("react");
var csv_1 = require("./lib/csv");
var CsvDownload = /** @class */ (function (_super) {
    __extends(CsvDownload, _super);
    function CsvDownload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            var _a = _this.props, suffix = _a.suffix, prefix = _a.prefix, bom = _a.bom, columns = _a.columns, datas = _a.datas, separator = _a.separator, noHeader = _a.noHeader, wrapColumnChar = _a.wrapColumnChar;
            var csv = csv_1.default(columns, datas, separator, noHeader, wrapColumnChar);
            var bomCode = bom ? '\ufeff' : '';
            var filename = _this.props.filename;
            if (filename.indexOf('.csv') === -1) {
                filename += '.csv';
            }
            if (suffix) {
                filename = typeof suffix === 'string' || typeof suffix === 'number'
                    ? filename.replace('.csv', "_" + suffix + ".csv")
                    : filename.replace('.csv', "_" + (new Date()).getTime() + ".csv");
            }
            if (prefix) {
                filename = typeof prefix === 'string' || typeof prefix === 'number'
                    ? prefix + "_" + filename
                    : (new Date()).getTime() + "_" + filename;
            }
            var blob = new Blob(["" + bomCode + csv], { type: 'text/csv;charset=utf-8' });
            FileSaver.saveAs(blob, filename);
        };
        return _this;
    }
    CsvDownload.prototype.render = function () {
        var _a = this.props, children = _a.children, text = _a.text;
        if (typeof children === 'undefined') {
            return (React.createElement("button", { onClick: this.handleClick, type: "button" }, text ? text : 'Download'));
        }
        return (React.createElement("div", { onClick: this.handleClick, onKeyPress: this.handleClick, role: "button", tabIndex: 0 }, children));
    };
    CsvDownload.defaultProps = {
        bom: true,
        columns: false,
        noHeader: false,
        separator: ',',
    };
    return CsvDownload;
}(React.Component));
exports.default = CsvDownload;
//# sourceMappingURL=index.js.map